var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-button',{attrs:{"isActive":_vm.isActive.italic(),"icon":'italic'},on:{"click":_vm.commands.italic}})}
var staticRenderFns = []

export { render, staticRenderFns }